/**
 * UI Utility Functions Index
 *
 * This file exports all UI-related utility functions for easier imports elsewhere.
 * Example usage: import { getScoreColor, getRatingLabel, textGradientVariants } from '@/lib/ui';
 */

export * from './variants';
